import PropTypes from 'prop-types';

import styles from './FormFields.module.css';

export const SwitchInput = ({ disabled = false, label, labelPosition = 'end', name, onChange, required = false, checked }) => {

  const handleInputChange = (e) => {
    e.target.value = (e.target.value === 'true') ? false : true;
    onChange(e);
  }

  return (
    <>
        <div className={styles.switchContainer}>
          {(labelPosition === 'start') && <label className="form-check-label me-2" htmlFor="flexSwitchCheckDefault">{ label }</label>}
          <div className="form-check form-switch">
              <input className={"form-check-input " + styles.switch} type="checkbox" role="switch" name={ name } value={ (checked === true) ? 'true' : 'false' } checked={ (checked === true) ? true : false } onChange={ handleInputChange } required={required} disabled={disabled} />
          </div>
          {(labelPosition === 'end') && <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{ label }</label>}
        </div>
    </>
  )
}

SwitchInput.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf(['start', 'end']),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  checked: PropTypes.bool,
}